import { Button } from '@direct-frontend/components';
import { ErrorBlankSad } from '#shared/components/ErrorBlank';
import { useGetCharacteristicValuesBySlug } from '../../api';
import { CharacteristicValuesListUI } from './CharacteristicValuesListUI';
import { type CharacteristicValuesListProps } from './types';

export function CharacteristicValuesList({ characteristicSlug }: CharacteristicValuesListProps) {
    const { currentData, error, isFetching, refetch } = useGetCharacteristicValuesBySlug({
        search_text: characteristicSlug,
    });

    if (error !== undefined) {
        return (
            <ErrorBlankSad
                title="Не удалось загрузить значения характеристики"
                controls={
                    <Button
                        type="button"
                        color="normal"
                        size="m"
                        isDisabled={isFetching}
                        isLoading={isFetching}
                        onClick={refetch}
                    >
                        Попробовать ещё раз
                    </Button>
                }
            />
        );
    }

    return <CharacteristicValuesListUI values={currentData?.values ?? []} characteristicSlug={characteristicSlug} />;
}
